import axios from '../../axios'

const state = {
	leagues: {},
}

const getters = {
	leagues(state) {
		return state.leagues
	}
}

const mutations = {
	SET_LEAGUES(state, leagues) {
		state.leagues = leagues
	}
}

const actions = {
	async getLeagues({ commit }) {
		commit('HTTP_IN_PROGRESS')
		return axios.get('leagues').then(response => {
			commit('HTTP_FINISHED')
			commit('SET_LEAGUES', response.data.data)
		})
		
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}